// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BHottV6ly3JnAPzYL2jd{position:relative;align-self:center}`, "",{"version":3,"sources":["webpack://./src/components/asset-management-system/custom-views/tabs/value/value-tab.scss"],"names":[],"mappings":"AAEA,sBACI,iBAAA,CACA,iBAAA","sourcesContent":["@import \"~styles/size\";\n\n.loaderPosition {\n    position: relative;\n    align-self: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpointXs": `458px`,
	"breakpointSm": `580px`,
	"breakpointMd": `768px`,
	"breakpointLg": `992px`,
	"breakpointXl": `1200px`,
	"breakpointXxl": `1600px`,
	"loaderPosition": `BHottV6ly3JnAPzYL2jd`
};
export default ___CSS_LOADER_EXPORT___;
